import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "tw-w-full tw-p-4 tw-flex tw-flex-col tw-gap-3",
  style: {"min-width":"min(40rem, calc(100vw - 4rem))"}
}
const _hoisted_2 = { class: "tw-flex tw-flex-col" }
const _hoisted_3 = { class: "tw-font-bold tw-text-lg" }
const _hoisted_4 = { class: "tw-font-semibold tw-text-sm" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "tw-w-full" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "tw-min-w-full"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-text-left"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "tw-font-medium" }, "Rp.:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.profesional?.nombre), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.especialidad?.nombre), 1)
    ]),
    _hoisted_5,
    _createElementVNode("div", null, [
      (Array.isArray(_ctx.itemsProcesados))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              value: _ctx.itemsProcesados,
              paginator: "",
              rows: 5,
              class: "tw-min-w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  field: "codigo",
                  header: "Codigo"
                }),
                _createVNode(_component_Column, {
                  field: "descripcion",
                  header: "Descripcion"
                }),
                _createVNode(_component_Column, {
                  field: "cantidad",
                  header: "Cantidad"
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsProcesados.split("\n"), (item, index) => {
              return (_openBlock(), _createElementBlock("p", {
                key: index,
                class: "tw-pl-4"
              }, _toDisplayString(item), 1))
            }), 128))
          ]))
    ])
  ]))
}